module.exports = __webpack_public_path__ + "img/US_ResourceStone_ua.b5628cde.webp";